// extracted by mini-css-extract-plugin
export default {"field":"ProductFiles_field__r2ZJQ"};